// utils/defaultTheme.ts
import { ThemeName } from '../types/theme';

let defaultTheme: ThemeName | null = null;

export const getDefaultTheme = async (): Promise<ThemeName> => {
    if (defaultTheme) {
        return defaultTheme; // Return cached value
    }
    
    try {
        const response = await fetch('/default-theme.json');
        const config = await response.json();
        defaultTheme = config.defaultTheme as ThemeName;
        return defaultTheme;
    } catch (error) {
        console.warn('Could not load default theme config, using hardcoded fallback');
        defaultTheme = 'modern-light'; // Hardcoded fallback
        return defaultTheme;
    }
};

// Synchronous version that returns the cached value or fallback
export const getDefaultThemeSync = (): ThemeName => {
    return defaultTheme || 'modern-light';
};